// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  font-family: "Courier New", Courier, monospace;
  color: rgb(30, 255, 0);
}

body {
  background-color: rgb(46, 46, 46);
  margin: 0;
  padding: 0;
}

#radar,
#my-board {
  display: grid;
  grid-template-columns: repeat(10, 40px);
  grid-template-rows: repeat(10, 40px);
  gap: 1px;
}

#radar button,
#my-board button {
  font-size: xx-large;
  font-weight: bolder;
  border: 1px solid rgb(21, 184, 0);
  cursor: pointer;
  transition: background-color 0.3s ease;
}

#radar button:hover,
#my-board button:hover {
  opacity: 0.7;
}

#game-container {
  display: flex;
  flex-direction: row;
  gap: 16px;
  justify-content: space-around;
  padding: 16px;
}

@media (max-width: 500px) {
  #game-container {
    flex-direction: column;
  }
}

.board-container {
  display: flex;
  flex-direction: column;
}
.rotate {
  transform: rotate(-90deg);
}
.clear {
  background-color: black;
}

.hit {
  background-color: rgb(255, 0, 0);
}

.miss {
  background-color: rgb(30, 255, 0);
}

#restart-button {
  padding: 8px 16px;
  background-color: black;
  border: 1px solid rgb(21, 184, 0);
  color: rgb(30, 255, 0);
  font-size: x-large;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

#restart-button:hover {
  background-color: rgb(21, 184, 0);
  color: black;
}

#top-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,8CAA8C;EAC9C,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,SAAS;EACT,UAAU;AACZ;;AAEA;;EAEE,aAAa;EACb,uCAAuC;EACvC,oCAAoC;EACpC,QAAQ;AACV;;AAEA;;EAEE,mBAAmB;EACnB,mBAAmB;EACnB,iCAAiC;EACjC,eAAe;EACf,sCAAsC;AACxC;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,iCAAiC;EACjC,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB","sourcesContent":["* {\n  font-family: \"Courier New\", Courier, monospace;\n  color: rgb(30, 255, 0);\n}\n\nbody {\n  background-color: rgb(46, 46, 46);\n  margin: 0;\n  padding: 0;\n}\n\n#radar,\n#my-board {\n  display: grid;\n  grid-template-columns: repeat(10, 40px);\n  grid-template-rows: repeat(10, 40px);\n  gap: 1px;\n}\n\n#radar button,\n#my-board button {\n  font-size: xx-large;\n  font-weight: bolder;\n  border: 1px solid rgb(21, 184, 0);\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n#radar button:hover,\n#my-board button:hover {\n  opacity: 0.7;\n}\n\n#game-container {\n  display: flex;\n  flex-direction: row;\n  gap: 16px;\n  justify-content: space-around;\n  padding: 16px;\n}\n\n@media (max-width: 500px) {\n  #game-container {\n    flex-direction: column;\n  }\n}\n\n.board-container {\n  display: flex;\n  flex-direction: column;\n}\n.rotate {\n  transform: rotate(-90deg);\n}\n.clear {\n  background-color: black;\n}\n\n.hit {\n  background-color: rgb(255, 0, 0);\n}\n\n.miss {\n  background-color: rgb(30, 255, 0);\n}\n\n#restart-button {\n  padding: 8px 16px;\n  background-color: black;\n  border: 1px solid rgb(21, 184, 0);\n  color: rgb(30, 255, 0);\n  font-size: x-large;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n#restart-button:hover {\n  background-color: rgb(21, 184, 0);\n  color: black;\n}\n\n#top-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
